import React from 'react';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import TabbedPage from '../components/TabbedPage';
import EmployeeIdFormatPage from './EmployeeIdFormatPage';
import FinancialYearPage from './FinancialYearPage';

const TABS = [
    { key: 'employee-ids', label: 'Employee IDs', icon: BadgeRoundedIcon, render: () => <EmployeeIdFormatPage /> },
    { key: 'financial-year', label: 'Financial Year', icon: CalendarMonthRoundedIcon, render: () => <FinancialYearPage /> },
];

export default function SettingsPage() {
    return <TabbedPage tabs={TABS} />;
}
